import React from 'react'
import { LocaleCodes } from '../../../../constants/localization.constants'
import { findTarget } from '../../../../utils/microcopy.utils'
import FormPageHero from '../formPageHero'

export const getFormIntroText = (webinarData: any, locale: string) => {
  if (webinarData.formIntro) return webinarData.formIntro

  if (
    webinarData.microcopy.values &&
    webinarData.category.number &&
    (webinarData.useCase === 'Upcoming' || webinarData.useCase === 'On Demand')
  ) {
    const type = webinarData.useCase === 'Upcoming' ? 'UpcomingFormINTRO' : 'OnDemandFormINTRO'
    const englishIntroText = `resource.${webinarData.category.number}.${type}.text`
    const globalIntroText = `resource.${locale.slice(3)}.${
      webinarData.category.number
    }.${type}.text`

    return findTarget(
      locale === LocaleCodes.ENGLISH.code ? englishIntroText : globalIntroText,
      webinarData.microcopy.values
    )
  }
}

export const getHeroData = (webinarData: any) => {
  if (webinarData.h1Title) {
    let webinarHeroType = ''

    if (webinarData.heroTextCentered) {
      webinarHeroType = webinarData.greyTextBar ? 'GRAY_TEXT_BAR' : 'CENTERED_NO_GRAY'
    } else {
      webinarHeroType = 'LEFT_ALIGNED'
    }

    const heroProps = {
      h1Title: webinarData.h1Title || '',
      image: {
        imageSrc: webinarData.mainImage.url,
        alt: webinarData.mainImage.alt,
      },
      heroSubtitle: webinarData.hero.subtitle,
      heroTextCentered: webinarData.hero.textCentered,
      heroEyebrow: webinarData.hero.eyebrow,
      heroFontBlack: webinarData.hero.fontBlack,
      greyTextBar: webinarData.greyTextBar,
      webinarHeroType,
      isWebinar: true,
    }

    return <FormPageHero {...heroProps} />
  } else {
    return null
  }
}
